import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

// Design System
import { PrimaryButton } from 'jl-design-system/elements/button/Button';

// Types
import { AppDispatch } from 'types/RootState.types';
import { PaymentButtonProps } from './PaymentButton.types';

// Config
import paymentButtonState from './PaymentButton.state';
import paymentTypeConstants from '@constants/paymentTypeConstants';
import { submitPayment, triggerPlaceOrderAndPayStartAnalytics } from '@redux/actions/payment/paymentActions';
import { saveTimePlaceOrderClicked } from '@redux/actions/timing/timingActions';

// Components
import ClickAndCollectCutOffPassedModal from '@components/click-and-collect-cut-off-passed-modal';
import TermsConditions from '@components/terms-conditions';

// Styles
import styles from './payment-button.scss';

export const PaymentButton = ({ buttonText, disabled, onClickOverride, type }: PaymentButtonProps) => {
  const dispatch: AppDispatch = useDispatch();
  const { isClickCollectOrder, isZeroOutstandingBalance, paymentProcessing, selectedPaymentType } =
    useSelector(paymentButtonState);

  const onPayButtonClick = () => {
    dispatch(saveTimePlaceOrderClicked());
    if (selectedPaymentType?.includes(paymentTypeConstants.POS_CREDIT)) {
      dispatch(triggerPlaceOrderAndPayStartAnalytics('posc'));
    }

    if (onClickOverride) {
      onClickOverride();
    } else {
      dispatch(submitPayment());
    }
  };

  const buttonLabel =
    buttonText ||
    (isZeroOutstandingBalance
      ? 'Place order'
      : selectedPaymentType?.includes(paymentTypeConstants.POS_CREDIT)
        ? 'Check your eligibility'
        : 'Place order and pay');

  return (
    <>
      {isClickCollectOrder && <ClickAndCollectCutOffPassedModal handleSubmit={onPayButtonClick} isPayment />}

      <PrimaryButton
        aria-label={buttonLabel}
        className={cx(styles.button, 'flex w-full')}
        data-testid="payment-submit-button"
        disabled={disabled}
        onClick={onPayButtonClick}
        submitting={paymentProcessing}
        type={type}
      >
        {buttonLabel}
      </PrimaryButton>

      <TermsConditions />
    </>
  );
};

export default PaymentButton;
